import React, { useState, useEffect } from "react";
import MaterialTable from 'material-table';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
// import DeletePartyRoleService from "../../../services/partyrole/deletePartyRoleService";
import { getTrans as t } from "../../../Localization/translations";

import { useNavigate } from "react-router-dom";
import PartyRoleViewList from "./view-partyrole";
import EditPartyRole from "./edit-partyrole";
import AddPartyRole from "./add-partyrole";
import Helper from "../../../Helper";

function PartyRoleContract({ id, contracttype, setTab, party_id }) {
    const [hideshow, setHideShow] = useState(false);
    const [hideshowedit, setHideShowEdit] = useState(false);
    const [hideshowview, setHideShowView] = useState(false);
    const [items, setItems] = useState([]);
    const [partyroleid, setPartyRoleID] = useState("");
    let navigate = useNavigate();
    const PARTY_ROLE_CHOICES = [
    { value: 'GUARANTOR', label: 'Guarantor' },
    { value: 'INSURANCE_PROVIDER', label: 'Insurance Provider' },
    { value: 'PRIVATE_LABEL_HOLDER', label: 'Private Label Holder' },
    ];

    const handelDefault = () => {
        let url = `${API}contracts/party-roles/?contract_id=${id}`;
        axios.get(url, { headers: authHeader() })
            .then(response => {
                if (response.data.success === 1) {
                    setItems(response.data.response);
                }
            })
            .catch(error => {
                toast.error("Failed to fetch party roles", {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            });
    };

    useEffect(() => {
        handelDefault();
    }, []);

    const handleView = (party_role_id) => {
        setPartyRoleID(party_role_id);
        setHideShowView(true);
    };

    const handleEdit = (party_role_id) => {
        setPartyRoleID(party_role_id);
        setHideShowEdit(true);
    };

    const handelDelete = (id) => {
        confirmAlert({
            title: '',
            message: 'Are you sure you want to delete this Party Role?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        axios.delete(`${API}contracts/party-roles/${id}/delete/`,{ headers: authHeader() }).then(
                            (response) => {
                                if (response.data.success) {
                                    toast.success(`${response.data.response}`, {
                                        position: "top-right",
                                        autoClose: 1000,
                                        hideProgressBar: false,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "light",
                                    });
                                    handelDefault();
                                } else {
                                    toast.error(`${response.data.error}`, {
                                        position: "top-right",
                                        autoClose: 1000,
                                        hideProgressBar: false,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "light",
                                    });
                                }
                            },
                        );
                    }
                },
                {
                    label: 'No',
                }
            ]
        });
    };

    return (
        <>
            <ToastContainer />
            {
                hideshow === false ?
                    hideshowedit === false ?
                        hideshowview === false ?
                            <div className="row py-2">
                                <div className="col-md-12">
                                    <div className="mb-0">
                                        <div className="header pb-0">
                                            <div className="d-lg-flex">
                                                <div>
                                                    <h5 className="mb-0">{t("Party Role")}</h5>
                                                </div>
                                                <div className="ms-auto my-auto mt-lg-0 mt-4">
                                                    <div className="ms-auto my-auto">
                                                        {/* <button 
                                                            className="btn btn-primary mb-0" 
                                                            onClick={() => setHideShow(true)}
                                                        >
                                                            +&nbsp; New Party Role
                                                        </button> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="body">
                                            <div className="p-0">
                                                <MaterialTable
                                                    style={{
                                                        padding: "0.5rem 0.5rem",
                                                        backgroundColor: "var(--bs-table-bg)",
                                                        borderBottomWidth: "1px",
                                                        boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                                    }}
                                                    // onRowClick={(event, rowData) => {
                                                    //     handleView(rowData.id);
                                                    // }}
                                                    columns={[
                                                        {
                                                            title: `${t("Party")}`,
                                                            field: "party",
                                                            headerStyle: {
                                                                verticalAlign: "inherit",
                                                                fontWeight: "bold",
                                                                textAlign: "left"
                                                            },
                                                            cellStyle: {
                                                                textAlign: "left",
                                                                fontSize: 12
                                                            },
                                                            render: rowData => (
                                                                <>
                                                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Party")}</div>
                                                                    <div className="hyperlink">{rowData.party_name}</div>
                                                                </>
                                                            ),
                                                        },
                                                        {
                                                            title: `${t("Role")}`,
                                                            field: "role",
                                                            headerStyle: {
                                                                verticalAlign: "inherit",
                                                                fontWeight: "bold",
                                                                textAlign: "left"
                                                            },
                                                            cellStyle: {
                                                                textAlign: "left",
                                                                fontSize: 12
                                                            },
                                                            render: rowData => (
                                                                <>
                                                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Role")}</div>
                                                                    <div>{PARTY_ROLE_CHOICES.find(choice => choice.value === rowData.role)?.label || rowData.role || "None"}</div>
                                                                </>
                                                            ),
                                                        },
                                                         {
                                                            title: `${t("Comment")}`,
                                                            field: "comment",
                                                            headerStyle: {
                                                                verticalAlign: "inherit",
                                                                fontWeight: "bold",
                                                                textAlign: "left"
                                                            },
                                                            cellStyle: {
                                                                textAlign: "left",
                                                                fontSize: 12
                                                            },
                                                            render: rowData => (
                                                                <>
                                                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Comment")}</div>
                                                                    <div>{PARTY_ROLE_CHOICES.find(choice => choice.value === rowData.comment)?.label || rowData.comment || "None"}</div>
                                                                </>
                                                            ),
                                                        },
                                                        // {
                                                        //     title: `${t("Created At")}`,
                                                        //     field: "created_at",
                                                        //     headerStyle: {
                                                        //         verticalAlign: "inherit",
                                                        //         fontWeight: "bold",
                                                        //         textAlign: "left"
                                                        //     },
                                                        //     cellStyle: {
                                                        //         textAlign: "left",
                                                        //         fontSize: 12
                                                        //     },
                                                        //     render: rowData => (
                                                        //         <>
                                                        //             <div className="d-xl-none tc d-md-none d-lg-none">{t("Created At")}</div>
                                                        //             <div>{rowData.created_at ? Helper.DateNormal(rowData.created_at) : "None"}</div>
                                                        //         </>
                                                        //     ),
                                                        // },
                                                        // {
                                                        //     title: `${t("Updated At")}`,
                                                        //     field: "updated_at",
                                                        //     headerStyle: {
                                                        //         verticalAlign: "inherit",
                                                        //         fontWeight: "bold",
                                                        //         textAlign: "left"
                                                        //     },
                                                        //     cellStyle: {
                                                        //         textAlign: "left",
                                                        //         fontSize: 12
                                                        //     },
                                                        //     render: rowData => (
                                                        //         <>
                                                        //             <div className="d-xl-none tc d-md-none d-lg-none">{t("Updated At")}</div>
                                                        //             <div>{rowData.updated_at ? Helper.DateNormal(rowData.updated_at) : "None"}</div>
                                                        //         </>
                                                        //     ),
                                                        // },
                                                    ]}
                                                    data={items}
                                                    // actions={[
                                                    //     {
                                                    //         icon: () => <img src={process.env.PUBLIC_URL + '/static/images/ic-edit.svg'} alt="Edit" />,
                                                    //         tooltip: "Edit",
                                                    //         onClick: (event, rowData) => {
                                                    //             handleEdit(rowData.id);
                                                    //         }
                                                    //     },
                                                    //     {
                                                    //         icon: () => <img src={process.env.PUBLIC_URL + '/static/images/ic-delete.svg'} alt="Delete" />,
                                                    //         tooltip: "Delete",
                                                    //         onClick: (event, rowData) => {
                                                    //             handelDelete(rowData.id);
                                                    //         }
                                                    //     }
                                                    // ]}
                                                    options={{
                                                        headerStyle: {
                                                            backgroundColor: "white",
                                                            color: "#245C7F",
                                                            fontSize: 12,
                                                        },
                                                        rowStyle: (rowData, index) => {
                                                            if (index % 2) {
                                                                return { backgroundColor: "#fff" };
                                                            }
                                                        },
                                                        sorting: true,
                                                        search: false,
                                                        toolbar: false,
                                                        paging: true,
                                                        pageSize: 3,
                                                        emptyRowsWhenPaging: false,
                                                        pageSizeOptions: [3, 15, 20, 50],
                                                        paginationType: "stepped",
                                                        showFirstLastPageButtons: false,
                                                        actionsColumnIndex: -1,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <PartyRoleViewList party_role_id={partyroleid} id={id} contracttype={contracttype} />
                        :
                        <EditPartyRole party_role_id={partyroleid} contractId={id} contract_term={contracttype} party_id={party_id} />
                    :
                    <AddPartyRole contract_id={id} contract_type={contracttype} tabindex={setTab} party_id={party_id} />
            }
        </>
    );
}

export default PartyRoleContract;